if (!customElements.get('back-in-stock')) {
  customElements.define(
    'back-in-stock',
    class BackInStock extends HTMLElement {
      constructor() {
        super();
        this.popup = this.querySelector('[data-popup]');
        this.closeButtons = this.querySelectorAll('[data-close]');
        this.body = this.querySelector('[data-body]');
        this.error = this.querySelector('[data-error]');
        this.success = this.querySelector('[data-success]');
        this.input = this.querySelector('input[type="email"]');
        this.sendButton = this.querySelector('[data-send]');
      }

      get variantId() {
        return Number(this.dataset.id);
      }

      get productId() {
        return Number(this.dataset.productId);
      }

      get locationId() {
        return Number(this.dataset.locationId);
      }

      connectedCallback() {
        this.setEventListeners();
      }

      openPopup() {
        this.body.classList.remove('hidden');
        this.success.classList.add('hidden');
        this.popup.classList.add('active');
      }

      closePopup() {
        this.popup.classList.remove('active');
        this.input.value = '';
      }

      setEventListeners() {
        const openButtons = document.querySelectorAll(`[data-open-bis="${this.variantId}"]`);

        if (openButtons.length === 0) return;
        openButtons.forEach((button) => {
          button.addEventListener('click', () => this.openPopup());
        });

        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.closePopup()));
        this.sendButton.addEventListener('click', () => this.sendRequest());
        if (window.innerWidth >= 990) {
          this.input.addEventListener('keydown', (event) => {
            if (event.code === 'Enter') this.sendRequest();
          });
        }
      }

      sendRequest() {
        const email = this.input.value;
        if (!this.validateEmail(email)) {
          this.error.classList.remove('hidden');
        } else {
          this.hasAttribute('data-v-app') ? this.sendAppRequest(email) : this.initBis(email);
        }
      }

      async initBis(email) {
        this.error.classList.add('active');
        const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VqyMEb';
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: `${email}`,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.variantId}`,
                },
              },
            },
          },
        };
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2023-12-15',
          },
          body: JSON.stringify(payload),
        };

        const response = await fetch(url, requestOptions);
        if (response.ok) {
          this.body.classList.add('hidden');
          this.success.classList.remove('hidden');

          setTimeout(() => {
            this.closePopup();
          }, 6000);
        }
      }

      async sendAppRequest(email) {
        const url = 'https://vee-bis-worker-prod.volodymyr-b-d87.workers.dev/api/back-in-stock';
        const gidVariantId = `gid://shopify/ProductVariant/${this.variantId}`;
        const gidLocationId = `gid://shopify/Location/${this.locationId}`;
        const payload = {
          email: email,
          variantId: gidVariantId,
          locationId: gidLocationId,
        };
        const request = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        };

        const response = await fetch(url, request);
        const result = await response.json();
        if (result.success) {
          this.body.classList.add('hidden');
          this.success.classList.remove('hidden');

          setTimeout(() => {
            this.closePopup();
          }, 6000);
        }
      }

      validateEmail(value) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return regex.test(value);
      }
    },
  );
}
